//const apiUrl = 'http://localhost:8000/api';
const apiUrl = "https://bs.aalantechsoft.com:8012/api";

export default apiUrl;
